"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var style_utils_1 = require("@nef/style-utils");
var Flex_1 = __importDefault(require("../../../Flex"));
var FontAwesomeIcon_1 = __importDefault(require("../../../FontAwesomeIcon"));
var Indicator_1 = __importDefault(require("../../../Indicator"));
var Sidebar_1 = require("../../../Sidebar");
var SidebarButtonContent_1 = __importDefault(require("../../../components/SidebarButtonContent"));
var Box_1 = __importDefault(require("../../../Box"));
var Tag_1 = __importDefault(require("../../../Tag"));
var SidebarButtonText_1 = __importDefault(require("../SidebarButtonText"));
var SidebarButtonSubButtons_1 = __importDefault(require("../SidebarButtonSubButtons"));
var SidebarButtonPopover_1 = __importDefault(require("../SidebarButtonPopover"));
var SidebarToggleButton = (function (_super) {
    __extends(SidebarToggleButton, _super);
    function SidebarToggleButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.parentRef = react_1.default.createRef();
        _this.contentRef = react_1.default.createRef();
        _this.open = function () {
            var _a = _this.props, onToggleClick = _a.onToggleClick, isOpen = _a.isOpen;
            var expanded = _this.context.expanded;
            onToggleClick === null || onToggleClick === void 0 ? void 0 : onToggleClick(true);
            _this.setState(function (prevState) { return ({
                isOpen: isOpen === undefined ? true : prevState.isOpen,
                previousExpanded: expanded
            }); });
        };
        _this.close = function () {
            var _a = _this.props, onToggleClick = _a.onToggleClick, isOpen = _a.isOpen;
            var expanded = _this.context.expanded;
            onToggleClick === null || onToggleClick === void 0 ? void 0 : onToggleClick(false);
            _this.setState(function (prevState) { return ({
                isOpen: isOpen === undefined ? false : prevState.isOpen,
                previousExpanded: expanded
            }); });
        };
        _this.onKeyDown = function (e) {
            var onClick = _this.props.onClick;
            if (e.key === "Enter" || e.key === " ") {
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
            }
        };
        _this.onClickToggle = function (event) {
            var _a = _this.props, onToggleClick = _a.onToggleClick, isOpen = _a.isOpen;
            var expanded = _this.context.expanded;
            if (event.type === "click" ||
                event.key === " " ||
                event.key === "Enter") {
                onToggleClick === null || onToggleClick === void 0 ? void 0 : onToggleClick();
                _this.setState(function (prevState) { return ({
                    isOpen: isOpen === undefined ? !prevState.isOpen : prevState.isOpen,
                    previousExpanded: expanded
                }); });
            }
        };
        _this.toggle = function (event) {
            var isOpen = _this.state.isOpen;
            if (event) {
                var _a = event, relatedTarget = _a.relatedTarget, type = _a.type;
                if ((type === "mouseenter" || type === "focus") &&
                    !window.escapedSidebarPopover) {
                    isOpen = true;
                }
                else if ((type === "mouseleave" || type === "blur") &&
                    ((relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.self) === window ||
                        !_this.parentRef.current.contains(relatedTarget)) &&
                    relatedTarget !== _this.parentRef.current.parentElement) {
                    isOpen = false;
                }
                else if (window.escapedSidebarPopover) {
                    isOpen = false;
                    window.escapedSidebarPopover = undefined;
                }
                if (event.type !== "keydown") {
                    _this.setState({
                        isOpen: isOpen
                    });
                }
            }
        };
        _this.isActiveChild = function () {
            var subButtons = _this.props.subButtons;
            return subButtons && subButtons.findIndex(function (sub) { return sub.active; }) !== -1;
        };
        _this.state = {
            isOpen: false,
            previousExpanded: false
        };
        return _this;
    }
    SidebarToggleButton.prototype.componentDidMount = function () {
        var expanded = this.context.expanded;
        this.setState({
            previousExpanded: expanded
        });
    };
    SidebarToggleButton.prototype.componentDidUpdate = function (prevProps, prevState) {
        var expanded = this.context.expanded;
        var _a = this.props, active = _a.active, isOpen = _a.isOpen, subButtons = _a.subButtons;
        var stateIsOpen = this.state.isOpen;
        var propIsUndefined = isOpen === undefined;
        if (subButtons) {
            var activeState = active || subButtons.findIndex(function (button) { return button.active; }) !== -1;
            if (isOpen === prevProps.isOpen &&
                stateIsOpen === prevState.isOpen &&
                expanded !== prevState.previousExpanded) {
                if (expanded &&
                    activeState &&
                    !(propIsUndefined ? stateIsOpen : isOpen)) {
                    this.open();
                }
                if (!expanded && (propIsUndefined ? stateIsOpen : isOpen)) {
                    this.close();
                }
            }
        }
    };
    SidebarToggleButton.prototype.render = function () {
        var _a = this.context, expanded = _a.expanded, rtl = _a.rtl;
        var _b = this.props, active = _b.active, bottom = _b.bottom, className = _b.className, disabled = _b.disabled, NasdaqIcon = _b.NasdaqIcon, iconClassName = _b.iconClassName, iconSetClassName = _b.iconSetClassName, id = _b.id, indicatorColor = _b.indicatorColor, indicatorValue = _b.indicatorValue, isOpen = _b.isOpen, onClick = _b.onClick, onToggleClick = _b.onToggleClick, subButtons = _b.subButtons, children = _b.children, footer = _b.footer, props = __rest(_b, ["active", "bottom", "className", "disabled", "NasdaqIcon", "iconClassName", "iconSetClassName", "id", "indicatorColor", "indicatorValue", "isOpen", "onClick", "onToggleClick", "subButtons", "children", "footer"]);
        var stateIsOpen = this.state.isOpen;
        var propsIsUndefined = isOpen === undefined;
        var isUserButton = false;
        var noAvatarArr = react_1.default.Children.toArray(children).filter(function (child) {
            if (typeof child === "string" ||
                (react_1.default.isValidElement(child) &&
                    child.type.displayName !== "Avatar")) {
                return true;
            }
            isUserButton = true;
            return false;
        });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            !expanded && (react_1.default.createElement(SidebarButtonPopover_1.default, { active: active, activeChild: this.isActiveChild(), bottom: bottom, containerRef: this.parentRef, isOpen: propsIsUndefined ? stateIsOpen : isOpen, onClick: !disabled ? onClick : undefined, subButtons: subButtons, target: id, trigger: null, toggle: propsIsUndefined ? this.toggle : undefined, iconSetClassName: iconSetClassName, iconClassName: iconClassName, isUserButton: isUserButton, footer: footer }, children)),
            react_1.default.createElement(SidebarButtonContent_1.default, __assign({}, props, { active: active || this.isActiveChild(), bottom: bottom, className: style_utils_1.classNames("sidebar--toggle-button", className), disabled: disabled, disableHover: expanded && !!subButtons, id: id, onFocus: !expanded && propsIsUndefined ? this.toggle : undefined, onBlur: !expanded && propsIsUndefined ? this.toggle : undefined, onMouseEnter: !expanded && propsIsUndefined ? this.toggle : undefined, onMouseLeave: !expanded && propsIsUndefined ? this.toggle : undefined, onKeyDown: subButtons && expanded
                    ? this.onClickToggle
                    : !disabled
                        ? this.onKeyDown
                        : undefined, onClick: subButtons && expanded
                    ? this.onClickToggle
                    : !disabled
                        ? onClick
                        : undefined, subButtons: subButtons, ref: this.contentRef }),
                react_1.default.createElement(Box_1.default, { className: "sidebar--button-icon-wrapper", marginLeft: expanded && !rtl ? 3 : "none", marginRight: expanded && rtl ? 3 : "none" }, NasdaqIcon ? (react_1.default.createElement(NasdaqIcon, { className: "sidebar--button-icon" })) : (react_1.default.createElement(FontAwesomeIcon_1.default, { className: "sidebar--button-icon", light: true, iconSetClassName: iconSetClassName, iconClassName: iconClassName }))),
                children && react_1.default.createElement(SidebarButtonText_1.default, null, noAvatarArr),
                expanded &&
                    indicatorColor &&
                    (indicatorValue ? (react_1.default.createElement(Tag_1.default, { className: "sidebar--button-indicator", color: indicatorColor }, indicatorValue)) : (react_1.default.createElement(Indicator_1.default, { className: "sidebar--button-indicator", color: indicatorColor }))),
                expanded && subButtons && (react_1.default.createElement(Box_1.default, { className: "sidebar--toggle-button--chevron-container", marginLeft: !rtl ? "auto" : "none", marginRight: rtl ? "auto" : "none", paddingHorizontal: 3 },
                    react_1.default.createElement(FontAwesomeIcon_1.default, { className: "sidebar--toggle-button--chevron", light: true, iconSetClassName: "fas", iconClassName: (propsIsUndefined
                            ? stateIsOpen
                            : isOpen)
                            ? "fa-chevron-up"
                            : "fa-chevron-down" })))),
            react_1.default.createElement(Flex_1.default, { ref: this.parentRef, className: "sidebar--popover-container", tabIndex: -1 }),
            react_1.default.createElement(SidebarButtonSubButtons_1.default, { active: active || this.isActiveChild(), isOpen: propsIsUndefined ? stateIsOpen : isOpen, subButtons: subButtons })));
    };
    SidebarToggleButton.contextType = Sidebar_1.SidebarContext;
    return SidebarToggleButton;
}(react_1.Component));
exports.default = SidebarToggleButton;
//# sourceMappingURL=index.js.map